import Vue from "vue";
import App from "./components/App/App.vue";
import router from "./router";
import store from "./store/store";
import "./filters";
import IdCell from "./components/IdCell/IdCell.vue";
import DateCell from "./components/DateCell/DateCell.vue";

Vue.config.productionTip = false;
// Ячейка ID для всех таблиц: хвост + копирование
Vue.component("IdCell", IdCell);
// Ячейка даты: день + время UTC с секундами
Vue.component("DateCell", DateCell);

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
